<template>
    <div class="box">
        <div class="box_container">
            <div style="height:10px;"></div>
            <!-- 下拉框 -->
            <div class="head" style="align-items: flex-start;">
                <div class="head_container">
                    <div class="flex" style="margin-bottom: 20px;">
                        <div class="flex head_dropDown">
                            <span>{{ $t('message.group') }}</span>
                            <el-select class="head_select" v-model="groupId" filterable
                                :placeholder="$t('message.pleaseselectagroup')">
                                <el-option v-for="item in group" :key="item.Cg_ID" :label="item.Cg_Name"
                                    :value="item.Cg_ID">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="flex head_dropDown">
                            <span>{{ $t('message.sender') }}</span>
                            <el-select class="head_select" v-model="sos.fsUser" filterable
                                :placeholder="$t('message.Pleaseselectuser')">
                                <el-option v-for="item in user" :key="item.User_ID" :label="item.User_Name"
                                    :value="item.User_ID">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="flex head_dropDown">
                            <span>{{ $t('message.Sendtime') }}</span>
                            <el-date-picker v-model="sos.fsStartTime" type="datetimerange" range-separator="~"
                                :picker-options="pickerOptions" :start-placeholder="$t('message.startrange')"
                                :end-placeholder="$t('message.endrange')">
                            </el-date-picker>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="flex head_dropDown">
                            <span>{{ $t('message.state') }}</span>
                            <el-select class="head_select" v-model="state" filterable
                                :placeholder="$t('message.Pleaseselectastatus')">
                                <el-option v-for="item in stateData" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="flex head_dropDown">
                            <span>{{ $t('message.Processor') }}</span>
                            <el-select class="head_select" v-model="sos.clUser" filterable
                                :placeholder="$t('message.Pleaseselectuser')">
                                <el-option v-for="item in user" :key="item.User_ID" :label="item.User_Name"
                                    :value="item.User_ID">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="flex head_dropDown">
                            <span>{{ $t('message.processtime') }}</span>
                            <el-date-picker v-model="sos.clStartTime" type="datetimerange" range-separator="~"
                                :picker-options="pickerOptions" :start-placeholder="$t('message.startrange')"
                                :end-placeholder="$t('message.endrange')">
                            </el-date-picker>
                        </div>
                    </div>
                </div>
                <div class="flex">
                    <div class="head_search head_dropDown mouse" @click="search()">
                        {{ $t('message.search') }}
                    </div>
                </div>
            </div>
            <!-- 下拉结束 -->
            <!-- 表格 -->
            <div class="table table_tow">
                <history-table :bool="bool" :tableData="tableData" :tableHead="tableHead" ref="history">
                    <el-table-column slot="operation" :label="$t('message.operate')" width="285">
                        <template slot-scope="scope">
                            <div class="table_box">
                                <span class="table_but mouse" @click="seeOssPosition(scope.row)">{{
                                    $t('message.ViewSOSlocation') }}</span>
                            </div>
                        </template>
                    </el-table-column>
                </history-table>
            </div>
            <!-- 分页 -->
            <div class="pagination">
                <div class="tip-sos">{{ $t('message.SOSalarmsintemporarygroupsarenotrecorded') }}</div>
                <el-pagination class="pagination_bottom" :current-page="paging.pageNo" background
                    :page-sizes="[20, 40, 60, 80]" layout="total,prev, pager, next,jumper,slot, sizes"
                    @size-change="sizeChange" @prev-click="prevClick" @next-click="nextClick"
                    @current-change="currentChange" :total="paging.total">
                    <span class="confirbtn" @click="comfir()">{{ $t('message.confirm') }}</span>
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script src=""></script>
<script>
import {querySOSRecord,queryGroupName,queryUserName} from "@/administration/history.js";
import historyTable from '@/components/history/table.vue';
import beasconfig from '@/api/beasconfig.js';
import axios from 'axios'
import qs from "qs";
export default {
  components: { 
    historyTable   
    },
    data() {
        return {
            pickerOptions: {
                disabledDate(time) {
                    let curDate = (new Date()).getTime();
                    let three = 90 * 24 * 3600 * 1000;
                    let threeMonths = curDate - three;
                    return time.getTime() > Date.now() || time.getTime() < threeMonths;
                }
            },
            valueStart:'',  //开始时间
            group:[     //群组
            ],
            groupId:'',   //群组id
            user:[     //用户
            ],
            userId:'',   //用户id
            stateData:[     //状态
                {
                    value:-1,
                    label:this.$t('message.Pleaseselectastatus')
                },
                {
                    value:0,
                    label:this.$t('message.Unprocessed')
                },
                {
                    value:2,
                    label:this.$t('message.Processed')
                }
            ],
            state:null,
            radiobroadcastData:[    //广播类型
                {
                    value:-1,
                    label:'请选择类型'
                },
                {
                    value:1,
                    label:'文本'
                },
                {
                    value:3,
                    label:'语音'
                }
            ],
            radiobroadcastType:'',
            currentPage4: 4,
            paging:{
                total:0,
                currentPage:1,
                pageNo:1,
                pageSize:20
            },
            sos:{
                clUser:'',  //发送人
                fsUser:'',  //处理人
                fsStartTime:'', //发送开始时间
                clStartTime:'' //处理结束时间  
            },
            // sos
            userInfo:{}, //用户信息
            chooselist: [],     //选中数据
            tableData:[],    //table数据
            tableHead:[
                {     
                            lable:this.$t('message.sender'),
                            prop:'sendName'
                            },
                            {     
                            lable:this.$t('message.group'),
                            prop:'Cg_Name'
                            },
                            {     
                            lable:this.$t('message.Sendtime'),
                            prop:'sos_start_time'
                            },
                            {    
                            lable:this.$t('message.Processor'),
                            prop:'operatorName'
                            },
                            {    
                            lable:this.$t('message.processtime'),
                            prop:'sos_end_time'
                            },
                            {    
                            lable:this.$t('message.state'),
                            prop:'sos_status'
                            }
            ],       //表头数据
            bool:true,
            historyIndex:0,
            music:null,
            showcontent: false,
            tipstext: '确定下载所选的录音吗？',
            sosMap:{},
            excelData:{
                ly:[],
                wb:[]
            },
            json_fields:{},
            downloadName:'记录'
        };
    },
    created() {
        this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
        this.getQueryGroupName();
        this.getQueryUserName();
        this.getQuerySOSRecord();
    },
    beforeCreate: function () { },
    mounted() { },
    methods: {
        seeOssPosition(row){   //查看oss
            console.log(row)
            let startDateTamp = Number(row.sos_start_time_stamp);
            let endDateTamp = Number(row.sos_end_time_stamp);
            let vv1 = this.$moment(startDateTamp).format("YYYY-MM-DD HH:mm:ss");
            let vv2 = this.$moment(endDateTamp).format("YYYY-MM-DD HH:mm:ss");
            var params = {
                Uid: row.sos_from_id,
                CorrdinateType: "Wgs84",  // "baidu",百度地图  "Wgs84" 谷歌地图
                startDateTime: vv1,
                endDateTime: vv2,
                startDateTamp: startDateTamp, //时间戳13位
                endDateTamp: endDateTamp
            };
            row.isStatus = 0; //用于判断是否处理了
            if (row.sos_status > 0) {
                axios.post(beasconfig.gpsUrlapi + '/shanli/gps/api/trace/gethistory?', qs.stringify(params), {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                }).then(res => {
                    // console.log('轨迹数据', res.data.Data)
                    if (res.data.Status == 1 && res.data.Data.length > 0) {
                        row.isStatus = 1;
                        this.$router.push(`/history/sosPosition?sosUser=${JSON.stringify(row)}`);
                    } else {
                        this.$message({
                            message: this.$t('message.Nolocationtrack'),
                            type: "warning",
                            center: true,
                            offset: 200
                        });
                    }
                })
            }else{
                this.$router.push(`/history/sosPosition?sosUser=${JSON.stringify(row)}`);
            }
            
        },
        getQuerySOSRecord(){   //sos记录
            let that = this;
            let sos = that.sos;
            let data = {
                uId:that.userInfo.id,
                pageNo:that.paging.pageNo,
                pageSize:that.paging.pageSize
            }
            if( sos.fsStartTime !='' && sos.fsStartTime != null ){  //发送时间
                data.sendStartAt = this.$moment(sos.fsStartTime[0]).valueOf();
                data.sendEndAt = this.$moment(sos.fsStartTime[1]).valueOf();
            } 
            if(sos.clStartTime != '' && sos.clStartTime != null){ //处理时间
                data.endStartAt = this.$moment(sos.clStartTime[0]).valueOf();
                data.endEndAt = this.$moment(sos.clStartTime[1]).valueOf();
            }
            if(sos.clUser != ''){   //操作人
                data.operator=sos.clUser
            }
            if(sos.fsUser != ''){ //发送人
                data.sendId=sos.fsUser
            }
            if(that.groupId != '' && that.groupId > 0 ){
                data.gId=that.groupId   //群组id
            }
            if(that.state != null){     //状态 0 待处理 2 已处理
                data.status=that.state
            }
            querySOSRecord(data).then(res =>{
                   if(res.data.code == 200){
                             that.paging.total = res.data.data.count;
                             let list = res.data.data.list;
                             if(list.length > 0){
                                list.forEach(item => {
                                    item.sos_start_time = this.$moment(item.sos_start_time_stamp).format("YYYY-MM-DD HH:mm:ss");
                                    item.sos_end_time = this.$moment(item.sos_end_time_stamp).format("YYYY-MM-DD HH:mm:ss");
                                });
                                that.tableData = list;
                            }else{
                                that.tableData = [];
                            }
                    }else {
                        that.$MessageWarning(res.data.msg);
                    }
            })
        },
        getQueryGroupName(){  //查询群组下拉
            let that = this;
            let data = {
                uId:that.userInfo.id
            }
            queryGroupName(data).then(res =>{
                    if(res.data.code == 200){
                        let list = res.data.data;
                        list.forEach(ele => {
                            if (ele.isactive == 1) {
                            } else {
                                ele.Cg_Name = ele.Cg_Name + `(${this.$t('message.deleted')})`
                            }
                        })
                         list.unshift({
                                Cg_ID:-1,
                                Cg_Name:this.$t('message.pleaseselectagroup')
                        })
                        this.group = list;
                    }else {
                        that.$MessageWarning(res.data.msg);
                    }
            })
        },
        getQueryUserName(){ //获取用户下拉
            let that = this;
            let data = {
                uId:that.userInfo.id
            }
            queryUserName(data).then(res=>{
                   if(res.data.code == 200){
                        that.user = res.data.data;
                        that.user.unshift({
                            User_ID:-1,
                            User_Name:this.$t('message.Pleaseselectuser')
                        })
                    }else {
                        that.$MessageWarning(res.data.msg);
                    }
            })
        },
        search(){      //搜索
            this.paging.pageNo = 1;
            this.refresh();
        },
         closepop() {
            this.showcontent = false
        },
        refresh(){      //刷新
                this.getQuerySOSRecord();
        },
        comfir() {  //确定按钮
                this.refresh();
            },
        sizeChange(pageSize) {
                //当前页数据发生改变时
                this.paging.pageSize = pageSize;
                this.refresh();
            },
            prevClick(pageNum) {
                //前进按钮
                this.paging.pageNo = pageNum;
                this.refresh();
            },
            nextClick(pageNum) {
                //退后按钮
                this.paging.pageNo = pageNum;
                this.refresh();
            },
            currentChange(pageNum) {
                //当前页发生改变时
                this.paging.pageNo = pageNum;
                this.refresh();
            }
    },
    watch: {
        //监听事件
        //监听事件
        groupId(val) {
            // console.log(val == -1)
            if (val == -1) {
                this.groupId = '';
            }
        },
        'sos.fsUser'(val){
            if (val == -1) {
                this.sos.fsUser = '';
            }
        },
        'sos.clUser'(val){
            if (val == -1) {
                this.sos.clUser = '';
            }
        },
        state(val){
            if(val == -1){
                this.state = null
            }
        }
    },
};
</script>

<style scoped lang="less">
.box {
    width: 100%;
    height: 100%;
    margin: auto;
    background-color: #ffffff;

    &_container {
        width: calc(100% - 20px);
        height: 100%;
        margin: auto;

        .head {
            width: 100%;
            padding: 10px 0px;
            background-color: #f0f0f0;
            border-radius: 5px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 10px;
            font-size: 15px;
            color: #5a5655;

            &_container {
                flex: 1;
                margin-left: 10%;
            }

            &_dropDown {
                font-size: 15px;
                color: #5a5655;
                margin-right: 20px;

                span {
                    margin-right: 5px;
                }
            }

            &_select {
                width: 160px;
                height: 40px;
            }

            &_picker {
                width: 280px !important;
                text-align: center;
            }

            &_search {
                width: 70px;
                height: 40px;
                line-height: 40px;
                text-align: center;
                background-color: #4d4d4d;
                background-size: 100% 100%;
                border-radius: 5px;
                color: #ffffff !important;
            }

            &_but {
                width: 110px;
                height: 40px;
                line-height: 40px;
                text-align: center;
                background-color: var(--main-color);
                border-radius: 3px;
                color: #ffffff !important;
                margin-right: 5px;
            }
        }

        .table_tow {
            height: calc(100vh - 73px - 235px);
        }

        .table {
            width: 100%;
            background-color: #f0f0f0;
            overflow: auto;
            color: #000000;

            &_box {
                width: 100%;
                text-align: center;
            }

            &_but {
                color: var(--main-color);
                margin-right: 10px;
            }
        }

        .pagination {
            width: 100%;
            // height: 80px;
            text-align: left;
            position: relative;
            background-color: #ffffff;

            /deep/.el-pagination__jump {
                margin-left: 0;
            }

            .tip-sos {
                text-align: right;
                color: #b2b2b2;
                height: 30px;
                line-height: 30px;
            }

            &_bottom {
                padding: 15px 0px;
                // position: absolute;
                // bottom: 0px;
                // left: 0px;
            }

            .confirbtn {
                background-color: #5a5657;
                padding: 0 6px;
                color: #ffffff;
                margin-left: 4px;
                cursor: pointer;
                border-radius: 2px;
                // line-height: 14px;
            }
        }
    }
}

.video-box {
    width: 100%;
    height: 480px;
}

vidio {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.bg_one {
    color: #ffffff;
    background: url("../../assets/history/select.png");
}

.bg_tow {
    color: #000000;
    background: url("../../assets/history/select1.png");
}

.flex {
    display: flex;
    align-items: center;
}
</style>